// Auto Generated by gen_criteria.py
export const CRITERION_D_LIST = [
  {
    id: "Assets",
    details:
      "Has Declared Assets in Public in at least one of the last 5 years",
    refs: "https://www.tisrilanka.org/mpassets/",
  },
  {
    id: "Attendance",
    details: "Has Over 70% Attendance in the Ninth Parliament",
    refs: "https://www.parliament.lk",
  },
  {
    id: "Moderate",
    details: "Is not associated with any extreme political Ideologies",
    refs: null,
  },
  {
    id: "Corruption",
    details: "Has No History of Corruption Charges",
    refs: null,
  },
  {
    id: "Criminal",
    details: "Has No Ongoing Criminal Case(s)",
    refs: null,
  },
  {
    id: "Economic",
    details: "Has Economic Experience at the National Level",
    refs: null,
  },
  {
    id: "Education",
    details: "Has a University Degree or Higher Education",
    refs: null,
  },
  {
    id: "Insurrections",
    details: "Has Not Participated in and Is Not Associated with insurrections",
    refs: "https://en.wikipedia.org/wiki/1987%E2%80%931989_JVP_insurrection",
  },
  {
    id: "Leader",
    details: "Is Leader of a Party with at least One Seat in Parliament",
    refs: null,
  },
  {
    id: "Military",
    details: "Has No Military Affiliations",
    refs: null,
  },
  {
    id: "Minister",
    details: "Has Held a Ministerial Position in the Past",
    refs: null,
  },
  {
    id: "ParaMilitary",
    details: "Has No Para-Military Affiliations",
    refs: null,
  },
  {
    id: "Presidency",
    details: "Will support abolishing the Executive Presidency ",
    refs: null,
  },
  {
    id: "RajapaksaCabinet",
    details: "Has never been Appointed to Cabinet by a Rajapaksa President",
    refs: null,
  },
  {
    id: "Seat",
    details: "Has Won a Electoral District Seat in the 2020 General Election",
    refs: "https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka",
  },
  {
    id: "SLPP",
    details: "Is not a Member nor a Former-Member of the SLPP",
    refs: "https://en.wikipedia.org/wiki/Sri_Lanka_Podujana_Peramuna",
  },
  {
    id: "Under65",
    details: "Is Under 65 years old (Born after 1959)",
    refs: null,
  },
  {
    id: "Against20A",
    details: "Has Voted Against the 20th Amendment",
    refs: "https://en.wikipedia.org/wiki/Twentieth_Amendment_to_the_Constitution_of_Sri_Lanka",
  },
];
